import { useEffect, useRef, useState } from "react";

// Keeps a loading UI on screen for at least `minMs` after mount,
// so very fast responses still feel intentional instead of flashing.
// Returns `displayLoading` — true until both (a) real loading finished
// AND (b) the minimum elapsed.
export const useMinLoading = (realLoading, minMs = 900) => {
  const start = useRef(Date.now());
  const [elapsed, setElapsed] = useState(false);

  useEffect(() => {
    const remaining = Math.max(0, minMs - (Date.now() - start.current));
    if (remaining === 0) {
      setElapsed(true);
      return;
    }
    const t = setTimeout(() => setElapsed(true), remaining);
    return () => clearTimeout(t);
  }, [minMs]);

  return realLoading || !elapsed;
};
